import { combineReducers } from '@reduxjs/toolkit';
import type { AnyAction } from 'redux';
import clearAuthenticatedState from './authActions';
import selectedBuildingReducer from './selectedBuildingSlice';
import dateRangeReducer from './dateRangeSlice';
import dateComparisonRangeReducer from './dateComparisonRangeSlice';
import ticketsFilterReducer from './ticketsFilterSlice';
import assetsFilterReducer from './assetsFilterSlice';
import devStateReducer from './devStateSlice';
import happyEnabledReducer from './happyEnabledSlice';
import sensorsFilterReducer from './sensorsFilterSlice';
import selectedTicketReducer from './selectedTicketSlice';
import locationStructureReducer from './locationStructureSlice';
import userReducer from './userSlice';
import emptyStateReducer from './emptyStateSlice';
import mapScreenReducer from './mapScreenSlice';
import liveDateRangeReducer from './liveDateRangeSlice';

const appReducer = combineReducers({
  selectedBuilding: selectedBuildingReducer,
  dateRange: dateRangeReducer,
  dateComparisonRange: dateComparisonRangeReducer,
  ticketsFilter: ticketsFilterReducer,
  assetsFilter: assetsFilterReducer,
  devState: devStateReducer,
  happyEnabled: happyEnabledReducer,
  sensorsFilter: sensorsFilterReducer,
  selectedTicket: selectedTicketReducer,
  locations: locationStructureReducer,
  user: userReducer,
  emptyState: emptyStateReducer,
  mapScreen: mapScreenReducer,
  liveDateRange: liveDateRangeReducer,
});

export { clearAuthenticatedState };

export const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: AnyAction,
) => (clearAuthenticatedState.match(action)
  ? appReducer(undefined, action)
  : appReducer(state, action));
